import AbstractInput from './AbstractInput';

enum NumberError { empty, format }

export default class Number extends AbstractInput<string, NumberError> {
  REGEX = /^\d+$/;

  empty = () => {
    return this.value === null || this.value === undefined || this.value.trim() === '';
  };

  errorMessage = () => {
    const displayError = this.validator();

    if (displayError === NumberError.empty) return 'El campo es requerido';
    if (displayError === NumberError.format) return 'No es un número';
    return null;
  };

  validator = () => {
    if(!this.allowEmpty) {
      if (this.empty()) return NumberError.empty;
    }
    if (this.empty()) return null;

    if (!this.REGEX.test(this.value)) return NumberError.format;

    return null;
  };

  getNumber = (): number | null => {
    const number = parseInt(this.value);
    if (isNaN(number) || number === undefined) {
      return null;
    }

    return number;
  }
}